import type { Section } from '../Search';

// Total number of results across every rendered section. This is the number the
// user actually sees in the dropdown (sections are built by each consumer's
// getSections), so it is what the SEARCH analytics event reports as
// `result_count` — and a count of 0 is exactly the UI's noResults state.
export const countSectionResults = (sections: Section[] | undefined): number =>
	(sections ?? []).reduce((total, section) => total + (section.results?.length ?? 0), 0);
